import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const RecordingIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <rect height="15" rx="7.5" stroke="currentColor" width="15" x="0.5" y="0.5" />
    <circle cx="8" cy="8" fill="currentColor" r="3" />
  </svg>
);
